import React, { useEffect, useState } from 'react';

import { AuthenticatedUserModel } from '../../models/security';
import {
  AidTypeModel,
  AreaModel,
  BusinessUnitsModel,
  GroupModel,
  HolidayModel,
  HourTypeModel,
  InterruptionReferenceModel,
  InterruptionTypeModel,
  ParametersModel,
} from '../../models';
import { EMPTY_ARRAY } from '../../constants';

import { requests } from '../../services/external/APIs';
import { InterruptionTypeAPI } from '../../services/external/APIs/interruptions/InterruptionsType.api';
import { InterruptionReferenceAPI } from '../../services/external/APIs/interruptions/InterruptionReferences.api';
import { AreasAPI } from '../../services/external/APIs/areas/Areas.api';
import { DaysAPI } from '../../services/external/APIs/days/Days.api';
import { HourTypesAPI } from '../../services/external/APIs/days/HourTypes.api';
import { GroupAPI } from '../../services/external/APIs/groups/Groups.api';
import { BusinessUnitsAPI } from '../../services/external/APIs/business-units/BusinessUnits.api';
import { ApplicationParametersAPI } from '../../services/external/APIs/application-parameters/ApplicationParameters.api';

/**
 * Consultamos todas las configuraciones necesarias para la aplicación
 * @param userInfo AuthenticatedUserModel
 * @returns InterruptionTypeModel[]
 * @returns InterruptionReferenceModel[]
 * @returns AreaMode[]
 * @returns GroupModel[]
 * @returns BusinessUnitsModel[]
 * @returns HourTypeModel[]
 * @returns AidTypeModel[]
 * @returns HolidayModel[]
 * @returns ParametersModel[]
 */
export const useGetConfigurations = (userInfo: AuthenticatedUserModel) => {
  const [interruptionTypesList, setInterruptionTypesList] =
    useState<InterruptionTypeModel[]>(EMPTY_ARRAY);

  const [interruptionTypesByUserList, setInterruptionTypesByUserList] =
    useState<InterruptionTypeModel[]>(EMPTY_ARRAY);

  const [interruptionTypesByEmployeePortalList, setInterruptionTypesByEmployeePortalList] =
    useState<InterruptionTypeModel[]>(EMPTY_ARRAY);

  const [interruptionReferenceTypesList, setInterruptionReferenceTypesList] =
    useState<InterruptionReferenceModel[]>(EMPTY_ARRAY);

  const [areasList, setAreasList] = useState<AreaModel[]>(EMPTY_ARRAY);
  const [groupList, setGroupList] = useState<GroupModel[]>(EMPTY_ARRAY);

  const [businessUnitsList, setBusinessUnitsList] = useState<BusinessUnitsModel[]>(EMPTY_ARRAY);

  const [hourTypes, setHourTypes] = useState<HourTypeModel[]>([] as HourTypeModel[]);

  const [aidTypesList, setAidTypesList] = useState<AidTypeModel[]>([] as AidTypeModel[]);

  const [holidaysList, setHolidaysList] = useState<HolidayModel[]>([] as HolidayModel[]);

  const [parametersApplication, setparametersApplication] = useState<ParametersModel[]>(
    [] as ParametersModel[],
  );

  useEffect(() => {
    InterruptionTypeAPI.getInterruptionsType().then((response: InterruptionTypeModel[]) =>
      setInterruptionTypesList(response),
    );

    InterruptionTypeAPI.getInterruptionsTypeByUser()
      .then((response: InterruptionTypeModel[]) => {
        setInterruptionTypesByUserList(response);
      })
      .catch((err) => console.log(err));

    InterruptionTypeAPI.getInterruptionsTypeByEmployeePortal()
      .then((response: InterruptionTypeModel[]) => {
        setInterruptionTypesByEmployeePortalList(response);
      })
      .catch((err) => console.log(err));

    InterruptionReferenceAPI.getInterruptionReferences().then(
      (response: InterruptionReferenceModel[]) => setInterruptionReferenceTypesList(response),
    );

    HourTypesAPI.getHousTypes()
      .then((response: HourTypeModel[]) => {
        setHourTypes(response);
      })
      .catch((error) => console.error(error));

    AreasAPI.getAreas()
      .then((response: AreaModel[]) => {
        setAreasList(response);
      })
      .catch((error) => console.error(error));

    GroupAPI.getGroups()
      .then((response: GroupModel[]) => {
        setGroupList(response);
      })
      .catch((error) => console.error(error));

    BusinessUnitsAPI.getBusinessUnits()
      .then((response: BusinessUnitsModel[]) => {
        setBusinessUnitsList(response);
      })
      .catch((error) => console.error(error));

    DaysAPI.getDays()
      .then((response: HolidayModel[]) => {
        setHolidaysList(response);
      })
      .catch((error) => console.error(error));

    ApplicationParametersAPI.getApplicationParameters()
      .then((response: ParametersModel[]) => {
        setparametersApplication(response);
      })
      .catch((err) => console.log(err));
  }, []);

  return {
    interruptionTypesList,
    areasList,
    groupList,
    businessUnitsList,
    hourTypes,
    aidTypesList,
    holidaysList,
    parametersApplication,
    interruptionReferenceTypesList,
    interruptionTypesByUserList,
    interruptionTypesByEmployeePortalList,
  };
};
